import React from "react";
export function nbsp(text) {
    return text.replace(/(?<=\s)([\p{L}\p{N}])\s/gu, "$1\u00A0");
}
export function getDjangoDataFromJson(jsonScriptId) {
    const element = document.getElementById(jsonScriptId);
    if (!element || !element.textContent) {
        throw new Error(`Element with id ${jsonScriptId} not found or it has no content`);
    }
    const data = JSON.parse(element.textContent);
    return data;
}
export function getFileDownloadLink() {
    const { fileDownloadLink } = window.ReactBridge;
    return fileDownloadLink;
}
export function makeKey() {
    var _a;
    return (_a = self === null || self === void 0 ? void 0 : self.crypto) === null || _a === void 0 ? void 0 : _a.randomUUID();
}
export const convertToPercent = (value) => {
    let result = (value * 100).toFixed(1).toString().replace(".", ",") + "%";
    return result;
};
export function roundToFourDecimalsIfNeeded(value) {
    if (!value.toString().includes("%")) {
        const stringValue = value.toString().replace(",", ".");
        const number = parseFloat(stringValue);
        if (isNaN(number)) {
            console.error(`Invalid number: ${value}`);
            return value;
        }
        const decimalIndex = stringValue.indexOf(".");
        if (decimalIndex !== -1) {
            const decimalPlaces = stringValue.length - decimalIndex - 1;
            if (decimalPlaces > 3) {
                return number.toFixed(4).toString().replace(".", ",");
            }
        }
        return number.toString().replace(".", ",");
    }
    const numericValue = value.replace("%", "");
    const stringValue = numericValue.replace(",", ".");
    const number = parseFloat(stringValue);
    if (isNaN(number)) {
        console.error(`Invalid number: ${numericValue}`);
        return value;
    }
    const fixedValue = number.toFixed(4);
    let formattedValue = fixedValue.replace(".", ",");
    formattedValue = formattedValue.replace(/0*$/, "");
    if (formattedValue.endsWith(",")) {
        formattedValue += "0";
    }
    formattedValue += "%";
    return formattedValue;
}
export function getFileExtension(filename) {
    var _a, _b;
    const parts = filename.split(".");
    if (parts.length < 2)
        return null; // no extension
    return (_b = (_a = parts.pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : null;
}
/**
 * "asdf, 3453, sdfs sdfs" -> ["asdf", "3453", "sdfssdfs"]
 */
export function getCommaSeparatedValues(string) {
    return string
        .split(",")
        .map((e) => e.replaceAll(" ", ""))
        .filter((e) => e !== "");
}
// Taken from https://stackoverflow.com/questions/71283327/react-chartjs-2-increase-spacing-between-legend-and-chart
export const legendPaddingIncreasePlugin = {
    id: "legendPaddingIncreasePlugin",
    beforeInit(chart /* at this point we are unable to define any types here */) {
        var _a;
        // Get reference to the original fit function
        const originalFit = (_a = chart === null || chart === void 0 ? void 0 : chart.legend) === null || _a === void 0 ? void 0 : _a.fit;
        // Override the fit function
        chart.legend.fit = function fit() {
            // Call original function and bind scope in order to use `this` correctly inside it
            originalFit.bind(chart.legend)();
            // Change the height as suggested in another answers
            this.height += 35;
        };
    },
};
export const getChartDataIndiMulti = (chartData, optionSelected, selectedChart, pageType) => {
    var _a;
    const datasets = [];
    let labelContent = pageType === "environmental_indicators_data"
        ? "Zakres górny"
        : ((_a = chartData === null || chartData === void 0 ? void 0 : chartData.value) !== null && _a !== void 0 ? _a : "");
    const filteredData = chartData.data.filter((item) => {
        // Check, whether the label item from the object appears in any of objects in array optionSelected
        return optionSelected === null || optionSelected === void 0 ? void 0 : optionSelected.some((selected) => selected.label === item.label);
    });
    if (filteredData.some(({ secondValue }) => secondValue !== undefined)) {
        datasets.push({
            label: "Zakres dolny",
            backgroundColor: "rgba(113, 155, 77, 1)",
            borderColor: "rgba(113, 155, 77, 1)",
            borderWidth: selectedChart === "bar-chart" ? 1 : 5,
            data: filteredData.map(({ secondValue }) => secondValue),
        });
    }
    if (filteredData.some(({ firstValue }) => firstValue !== undefined)) {
        datasets.push({
            label: labelContent,
            backgroundColor: "rgba(91, 155, 213, 255)",
            borderColor: "rgba(91, 155, 213, 255)",
            borderWidth: selectedChart === "bar-chart" ? 1 : 5,
            data: filteredData.map(({ firstValue }) => firstValue),
        });
    }
    return {
        labels: filteredData.flatMap((item) => item.label),
        datasets,
    };
};
export const getChartDataZite = (chartData, selectedChart, multiSelects) => {
    var _a, _b, _c;
    const datasets = [];
    if (JSON.stringify(multiSelects) !== "{}" &&
        multiSelects["area"] != undefined &&
        ((_a = multiSelects["area"]) === null || _a === void 0 ? void 0 : _a.length) !== 0) {
        // Getting label values from multiSelects.country and multiSelects.year
        const selectedCountryLabels = ((_b = multiSelects.area) === null || _b === void 0 ? void 0 : _b.map((option) => option.label)) || [];
        const selectedYearLabels = ((_c = multiSelects.year) === null || _c === void 0 ? void 0 : _c.map((option) => {
            return option.label;
        })) || [];
        // Filtering chartData.data based on got country labels
        const filteredData = chartData.data.filter((item) => selectedCountryLabels.includes(item.area));
        // Filtering nested data based on chosen years
        const fullyFilteredData = filteredData.map((item) => {
            return Object.assign(Object.assign({}, item), { data: item.data.filter((e) => selectedYearLabels.includes(e.year.toString())) });
        });
        let years = fullyFilteredData[0].data.flatMap((e) => {
            return e.year;
        });
        let data = fullyFilteredData.map((e) => {
            return e.data.flatMap((params) => {
                if (typeof params.value == "string") {
                    return parseFloat(params.value.replace(",", "."));
                }
                else {
                    return params.value;
                }
            });
        });
        const COLORS = [
            // maximum 5 countries, so we just need 5 colors
            {
                backgroundColor: "rgba(113, 155, 77, 1)",
                borderColor: "rgba(113, 155, 77, 1)",
            },
            {
                backgroundColor: "#7185d6",
                borderColor: "#7185d6",
            },
            {
                backgroundColor: "#ffd668",
                borderColor: "#ffd668",
            },
            {
                backgroundColor: "#ca95e2",
                borderColor: "#ca95e2",
            },
            {
                backgroundColor: "#2ec988",
                borderColor: "#2ec988",
            },
        ];
        fullyFilteredData.forEach((element, index) => {
            datasets.push({
                label: fullyFilteredData.flatMap((e) => e.area)[index],
                backgroundColor: COLORS[index].backgroundColor,
                borderColor: COLORS[index].borderColor,
                borderWidth: selectedChart === "bar-chart" ? 1 : 5,
                data: data[index],
            });
        });
        return {
            labels: years,
            datasets,
        };
    }
    else {
        return {
            labels: [],
            datasets,
        };
    }
};
export const getChartDataPite = (chartData, selectedChart, multiSelects) => {
    var _a, _b, _c;
    if (!chartData) {
        return {
            labels: [],
            datasets: [],
        };
    }
    const selectedYearLabels = ((_a = multiSelects === null || multiSelects === void 0 ? void 0 : multiSelects.year) === null || _a === void 0 ? void 0 : _a.map((option) => option.label)) || [];
    if (selectedYearLabels.length === 0) {
        return {
            labels: [],
            datasets: [],
        };
    }
    const filteredData = chartData.data.filter((item) => selectedYearLabels.includes(item.year));
    const labels = filteredData.map((item) => item.year);
    const values = filteredData.map((item) => {
        const rawValue = item.value;
        if (rawValue === null || rawValue === undefined) {
            return null;
        }
        if (typeof rawValue === "string") {
            const normalized = rawValue.replace(",", ".");
            const parsed = parseFloat(normalized);
            return Number.isNaN(parsed) ? null : parsed;
        }
        return rawValue;
    });
    return {
        labels,
        datasets: [
            {
                label: (_c = (_b = chartData.label) !== null && _b !== void 0 ? _b : chartData.value) !== null && _c !== void 0 ? _c : "Polska",
                backgroundColor: "rgba(91, 155, 213, 1)",
                borderColor: "rgba(91, 155, 213, 1)",
                borderWidth: selectedChart === "bar-chart" ? 1 : 5,
                data: values,
            },
        ],
    };
};
// TODO Perhaps it is possible to create one function for Zite and Social filtering and separate logic just for converting the filtered data into "datasets"
export const getChartDataSocial = (multiSelects, chartData, selectedChart, isPoland) => {
    var _a, _b, _c;
    const hasValidData = chartData.data && chartData.data.length > 0;
    if (!hasValidData) {
        return { labels: [], datasets: [] };
    }
    if (isPoland) {
        const datasets = [];
        let labels = [];
        let values = [];
        chartData.data.forEach((item) => {
            labels.push(item.year);
            values.push(item.value);
        });
        datasets.push({
            label: "",
            backgroundColor: "rgba(91, 155, 213, 1)",
            borderColor: "rgba(91, 155, 213, 1)",
            borderWidth: selectedChart === "bar-chart" ? 1 : 5,
            data: values,
        });
        return {
            labels: labels,
            datasets,
        };
    }
    else {
        // Voivodeship format
        const selectedYearLabels = ((_a = multiSelects.year) === null || _a === void 0 ? void 0 : _a.map((option) => option.label)) || [];
        const hasYearFilter = multiSelects.year !== undefined && selectedYearLabels.length > 0;
        const filteredData = hasYearFilter
            ? chartData.data.filter((item) => selectedYearLabels.includes(item.year.toString()))
            : [];
        const datasets = [];
        let labels = [];
        let values = [];
        if (filteredData.length > 0) {
            const objOrigin = (_b = filteredData[0]) === null || _b === void 0 ? void 0 : _b.value;
            const keyValueArray = objOrigin && Object.keys(objOrigin).map((key) => {
                return { key: key, value: objOrigin[key] };
            });
            keyValueArray === null || keyValueArray === void 0 ? void 0 : keyValueArray.sort((a, b) => {
                const nameA = a.key.toLowerCase();
                const nameB = b.key.toLowerCase();
                return nameA.localeCompare(nameB);
            });
            if (keyValueArray !== undefined && keyValueArray !== null) {
                for (const key of keyValueArray) {
                    labels.push(key.key);
                    values.push(key.value);
                }
            }
            else if (keyValueArray === null) {
                labels.push("brak danych");
                values.push("brak danych");
            }
            datasets.push({
                label: (_c = filteredData[0]) === null || _c === void 0 ? void 0 : _c.year,
                backgroundColor: "rgba(91, 155, 213, 1)",
                borderColor: "rgba(91, 155, 213, 1)",
                borderWidth: selectedChart === "bar-chart" ? 1 : 5,
                data: values,
            });
            return {
                labels: labels,
                datasets,
            };
        }
        return { labels: [], datasets: [] };
    }
};
export function getLabelForValue(options, value) {
    const labels = {};
    options.forEach(({ value, label }) => (labels[value] = label));
    return labels[value];
}
const CHEMICAL_FORMULAS = {
    CO2: { base: "CO", subscript: "2" },
    SO2: { base: "SO", subscript: "2" },
    NO2: { base: "NO", subscript: "2" },
    CH4: { base: "CH", subscript: "4" },
    N2O: { base: "N", subscript: "2O" },
    H2O: { base: "H", subscript: "2O" },
    NOx: { base: "NO", subscript: "x" },
    NOX: { base: "NO", subscript: "x" },
};
const CHEMICAL_PATTERN = /(NOx|NOX|N2O|H2O|CO2|SO2|NO2|CH4)/g;
export function formatChemicalFormulas(text) {
    if (!text)
        return text;
    const parts = text.split(CHEMICAL_PATTERN);
    return parts.map((part, index) => {
        const formula = CHEMICAL_FORMULAS[part];
        if (formula) {
            return React.createElement("span", { key: `formula-${index}`, style: { whiteSpace: "nowrap" } }, formula.base, React.createElement("sub", null, formula.subscript));
        }
        return part;
    });
}
